<template>
    <div id="app" class="font-size" :class="{bgWhite: $route.name.includes('stores')}">
        <notification-panel></notification-panel>
        <portal-target name="sc-modal"></portal-target>
        <transition :name="transitionName" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
import NotificationPanel from './plugins/notification-panel/notification-panel';
import moment from 'moment';
import axios from 'axios';

require('./styles/main.scss');

const DEFAULT_TRANSITION = 'slide-left';

export default {
  components: {NotificationPanel},
  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      browserRefresh: null
    };
  },

  beforeDestroy() {
    this.clearRefresh();
  },
  created() {
    // On refresh, check for local storage items
    this.$store.dispatch('i18n/LOCALES_CHECK');
    this.$store.dispatch('STORE_NAME_CHECK');

    //
    if (!this.$store.state.user) {
      axios.get(`${process.env.VUE_APP_API_BASE}/a/user?api_key=${this.$store.getters.key}`)
        .then((res) => {
          this.$store.dispatch('SET_USER', res.data);
        });
    }
    //

    this.$router.beforeEach((to, from, next) => {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      let transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });

    this.autoRefresh();
  },
  methods: {
    clearRefresh() {
      if (this.browserRefresh !== null) {
        clearInterval(this.browserRefresh);
      }
    },

    autoRefresh() {
      this.clearRefresh();
      this.browserRefresh = setTimeout(() => {
        if (moment().format('HH') === '00') {
          location.reload();
        }
        this.autoRefresh();
      }, 3600000);
    }
  }
};
</script>

<style lang='scss'>

:root {
    --shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    --shadow-inset: inset 0 1px 3px 0 rgba(0, 0, 0, 0.15);
}

#app {
    height: 100vh;
    width: 100vw;
    position: relative;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;

    font-family: $text-font-main;
    color: $brand-black;
    background-color: #eaeaea;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    user-select: none;
    overflow: hidden;

    &.bgWhite {
        background-color: white;
    }
}

.font-size {
    font-size: 1.25em;
}

@media only screen and (max-width: 719px) {
    .font-size {
        font-size: 1em;
    }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition-duration: 0.5s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    transform: translate(-2em, 0);
}


.slide-enter-active, .slide-leave-active {
    position: relative;
    transition: all ease-in-out .5s;
}

.slide-enter-to, .slide-leave {
    transform: translateY(0);
    opacity: 1;
}

.slide-enter, .slide-leave-to {
    transform: translateY(50px);
    opacity: 0;
}

</style>